import { useState } from 'react';
import { RealtimeParkingViewModel } from '../../../viewmodels/RealtimeParkingViewModel';
import { RealtimeSettings, AvailableFolders } from '../types';

export function useRealtimeSettings(projectId: string) {
  const [settings, setSettings] = useState<RealtimeSettings>({
    learningImageFolder: '',
    roiFile: '',
    varThreshold: 50,
    learningRate: 0.001,
    iterations: 1
  });

  const [availableFolders, setAvailableFolders] = useState<AvailableFolders>({
    learning: [],
    roi: []
  });

  const loadAvailableFolders = async () => {
    try {
      console.log('Loading available folders for projectId:', projectId);
      const folders = await RealtimeParkingViewModel.loadAvailableFolders(projectId);
      setAvailableFolders(folders);
    } catch (error) {
      console.error('\uD3F4\uB354 \uBAA9\uB85D \uB85C\uB4DC \uC2E4\uD328:', error);
    }
  };

  const handleSettingChange = (field: string, value: any) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return {
    settings,
    availableFolders,
    loadAvailableFolders,
    handleSettingChange,
  };
}
